module.exports = __webpack_public_path__ + "static/8-d0c2a888b38ce468e882415bd8325fb8.png";